import Icon from '../components/Icon.vue'

Icon.register({
  peace: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM432 256C432 287.9 423.8 318 409.4 344.2L280 240.6V75C366.2 90.2 432 165.5 432 256zM216 437C182.1 431.1 151.5 415.8 126.7 394L216 322.6V437zM280 322.6L369.3 394C344.5 415.8 313.9 431.1 280 437V322.6zM216 75V240.6L86.6 344.2C72.2 318 64 287.9 64 256 64 165.5 129.8 90.2 216 75z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/peace.js
// module id = n8Js
// module chunks = 144